<template>
  <div class="inline left index">
    <div class="index-field">
      <input
        class="input"
        ref="index"
        dir="rtl"
        type="text"
        inputmode="numeric" pattern="[0-9]*"
        maxlength="7"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('blur')"
        v-bind:value="value"
      />
    </div>
    <div class="float">,0</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
  },
  computed: {
    formatedValue() {
      return parseInt(this.value);
    }
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.index-field {
  position: relative;
  width: 150px;
  background: $black;
  border-radius: 4px 0px 0px 4px;

  .input {
    z-index: 1;
    width: 150px;
    padding-left: 0px;
    background: none;
    color: $white;
    background: repeating-linear-gradient(90deg, $white 0, $white 1ch, transparent 0, transparent 1.5ch) right 16px bottom 5px/ 10ch 1px no-repeat;
    letter-spacing: 0.5ch;
    border: 0 !important;
    font: 1.2rem monospace!important;

    &:focus {
      outline: none !important;
      border: 0;
      box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0)!important;
    }

    &:invalid {
      box-shadow: none!important;;
    }
  }
}

.float {
  font: 1.2rem monospace!important;
  height: 25px;
  padding: 5px;
  background: repeating-linear-gradient(90deg, $white 0, $white 1ch, transparent 0, transparent 1.5ch) right 5px bottom 5px/ 1ch 1px no-repeat $red;
  // letter-spacing: 0.5ch;
  border-radius: 0px 5px 4px 0px;
  height: 100%;
  color: $white;
}

.unit {
  font-size: 0.8rem;
  text-align: center;
  width: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/Form/BecomeFields/IndexField.vue